/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircuitResistor = createReactComponent("circuit-resistor", "IconCircuitResistor", [
  ["path", { d: "M2 12h2l2 -5l3 10l3 -10l3 10l3 -10l1.5 5h2.5", key: "svg-0" }]
]);

export { IconCircuitResistor as default };
//# sourceMappingURL=IconCircuitResistor.js.map
